/* eslint import/no-extraneous-dependencies: 0 */
import { JavascriptGenerator } from './javascriptGenerator';
import * as control from './controlBlocks';
import * as controlJunior from './controlJuniorBlocks';
import * as variables from './variableBlocks';
import * as procedures from './procedureBlocks';
import * as logic from './logicBlocks';
import * as math from './mathBlocks';
import * as outputs from './outputsBlocks';
import * as text from './textBlocks';
import * as lcd from './lcdBlocks';
import * as serial from './serialBlocks';
import * as radio from './radioBlocks';
import * as bluetooth from './bluetoothBlocks';
import * as inputDigital from './inputDigital';
import * as microbit from './microbitBlocks';
import * as bhoot from './bhootBlocks';
import * as builtin from './builtinBlocks';
import * as drone from './droneBlocks';

const javascriptGenerator = new JavascriptGenerator();

const generators = {
  // Primero los built-in de Blockly, para que cualquier módulo de acá abajo
  // pueda sobreescribir uno si el set legacy lo pide distinto.
  ...builtin,
  ...control,
  ...controlJunior,
  ...variables,
  ...procedures,
  ...logic,
  ...math,
  ...outputs,
  ...text,
  ...lcd,
  ...serial,
  ...radio,
  ...bluetooth,
  ...inputDigital,
  ...microbit,
  ...bhoot,
  ...drone,
};

Object.keys(generators).forEach(name => {
  javascriptGenerator.forBlock[name] = generators[name];
});

export default javascriptGenerator;